// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1Cdxt","list":"PatternAutocomplete_list__1R7Cb"};